import styled from 'styled-components';
import { colors } from '../../../stylesheets';

export const Wrapper = styled.div((props) => ({
  width: '100vw',
  height: '100vh',
  left: '0',
  right: '0',
  top: '0',
  bottom: '0',
  position: 'absolute',
  zIndex: '1000',
  backgroundColor: colors.primary + '31',
}));
